import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { PipelineParams, PipelinePlacement, PipelineStage } from '@recruitee/http/types';

import { defaultPipelineParams } from './consts';

@Injectable({ providedIn: 'root' })
export class PipelineStagesHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(
    id: string,
    params: PipelineParams = defaultPipelineParams,
  ): Observable<{ stages: PipelineStage[]; id: string }> {
    return this.httpApi.get(`/offers/${id}/placements`, params).pipe(
      map(response => ({
        stages: response.stages,
        id,
      })),
    );
  }

  public fetchPlacement(offerId: number, candidateId: number): Observable<PipelinePlacement> {
    return this.httpApi
      .get(`/offers/${offerId}/candidates/${candidateId}/placement`)
      .pipe(map(response => response.placement));
  }
}
